import { Field } from '@welbe/design-system';
import { CustomSelect } from './CustomSelect';

interface CustomSelectFieldProps {
	label: string;
	invalid?: boolean;
	error?: string;
	required?: boolean;
	disabled?: boolean;
	readOnly?: boolean;
	loading?: boolean;
	options: { id: string; name: string }[];
	value: string;
	onChange: (id: string) => void;
	placeholder?: string;
}

export const CustomSelectField = ({
	label,
	invalid,
	error,
	required,
	disabled,
	readOnly,
	loading,
	options,
	value,
	onChange,
	placeholder,
}: CustomSelectFieldProps): JSX.Element => (
	<Field.Root
		invalid={!!error || !!invalid}
		required={required}
		disabled={disabled}
		readOnly={readOnly}
	>
		<Field.Label>
			{label} {required && <Field.RequiredIndicator />}
		</Field.Label>
		<CustomSelect
			options={options}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			loading={loading}
			disabled={disabled}
			readOnly={readOnly}
		/>
		{error && <Field.ErrorText>{error}</Field.ErrorText>}
	</Field.Root>
);
